export const FIELDS = {

  COMPANY_NAME: 'companyName',
  SHORT_NAME: 'shortName',
  NUMBER: 'number',
  NUMBERING_PREFIX: 'numberingPrefix',
  SCOPE: 'scope',
  WEBSITE: 'website',
  LINKEDIN: 'linkedin',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TAX_EIN: 'taxEIN',
  BUSINESS_ENTITY_TYPE: 'businessEntityType',
  STATE_OF_INCORPORATION: 'stateOfIncorporation',
  IS_DEMO: 'isDemo',
  CHANNEL_NAME: 'channelName',
  ID: 'id',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  COMPANY_LOCATION_ID: 'companyLocationId',
  PHYSICAL_ADDRESS1: 'physicalAddress1',
  PHYSICAL_ADDRESS2: 'physicalAddress2',
  PHYSICAL_CITY: 'physicalCity',
  PHYSICAL_STATE: 'physicalState',
  PHYSICAL_ZIPCODE: 'physicalZipcode',
  EMAIL: 'email',
  PHONE: 'phone',
  FAX: 'fax',
  IS_VERIFIED: 'isVerified',
  IS_CHANNEL: 'isChannel',
  COMPANY_ROLES_AS_TEXT: 'companyRolesAsText',
  COMPANY_ROLES_AS_IDS: 'companyRolesAsIds',
  COMPANY_CHANNEL: 'companyChannel',
  COMPANY_STATUS: 'companyStatus',
  CONTACT_ID: 'contactId',
  ASP_NET_USER_ID: 'aspNetUserId',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  FULL_NAME: 'fullName',
  WORK_TITLE: 'workTitle',
  WORK_DEPARTMENT: 'workDepartment',
  WORK_EMAIL: 'workEmail',
  WORK_PHONE1: 'workPhone1',
  WORK_PHONE1_EXTN: 'workPhone1Extn',
  WORK_PHONE1_TYPE_ID: 'workPhone1TypeId',
  WORK_FAX: 'workFax',
  PARENT_COMPANY_ID: 'parentCompanyId',
  PARENT_COMPANY_SHORT_NAME: 'parentCompanyShortName',
  PARENT_COMPANY_NAME: 'parentCompanyName',
  NOTES: 'notes',
  IS_MAILING_SAME: 'isMailingSame',
  MAILING_ADDRESS1: 'mailingAddress1',
  MAILING_ADDRESS2: 'mailingAddress2',
  MAILING_CITY: 'mailingCity',
  MAILING_STATE: 'mailingState',
  MAILING_ZIPCODE: 'mailingZipcode',
  IS_SHIPPING_SAME: 'isShippingSame',
  SHIPPING_ADDRESS1: 'shippingAddress1',
  SHIPPING_ADDRESS2: 'shippingAddress2',
  SHIPPING_CITY: 'shippingCity',
  SHIPPING_STATE: 'shippingState',
  SHIPPING_ZIPCODE: 'shippingZipcode',
};